/**
 * Trailblazers galaxy-map background images.
 *
 * A single translucent, recolourable vector backdrop rendered BEHIND the dotted
 * grid on a game's galaxy map (admin builder + player view) to give the map a
 * bit of personality. Like the node icons, each SVG is applied as a CSS
 * `mask-image` so the admin can tint it any colour and set its opacity at render
 * time (see `.trl-map-builder__bg`); the file's own fills are irrelevant.
 *
 * Mirrors the `mapIcons.ts` registry pattern: served art (see ./art.ts), listed
 * for the picker, and resolved back from a stored id via {@link getMapBackgroundUrl}.
 */
import { artUrl } from './art';
function background(id, label, asset) {
    return { id, label, get url() { return artUrl(asset); } };
}
/**
 * The pickable background images, in display order. `id` is stored on the map
 * (`TrlMapBackground.image`); a map with no image renders no backdrop.
 */
export const TRL_MAP_BACKGROUNDS = [
    background('map-bg-1', 'Frame', 'trl/map-backgrounds/map-bg-1.svg'),
];
const BG_BY_ID = new Map(TRL_MAP_BACKGROUNDS.map((b) => [b.id, b]));
/**
 * Resolve a stored background id to its served SVG URL, or '' when the id is
 * absent or unknown (caller then renders no backdrop).
 */
export function getMapBackgroundUrl(id) {
    if (!id)
        return '';
    return BG_BY_ID.get(id)?.url ?? '';
}
